import { GallectionType } from '../../types/gallection';
import { stashFolderSchema, collectionFolderSchema, galleryFolderSchema, stashListSchema, collectionListSchema, galleryListSchema, } from './schemas/folder';
import { normalize } from '.';
import { deviationListSchema, deviationSchema } from './schemas/deviation';
import { userListSchema, userSchema } from './schemas/user';
export function getGallectionSchema(gallection) {
    switch (gallection.type) {
        case GallectionType.STASH:
            return stashFolderSchema;
        case GallectionType.COLLECTION:
            return collectionFolderSchema;
        case GallectionType.GALLERY:
        default:
            return galleryFolderSchema;
    }
}
export function getGallectionListSchema(gallections) {
    var _a;
    switch ((_a = gallections[0]) === null || _a === void 0 ? void 0 : _a.type) {
        case GallectionType.STASH:
            return stashListSchema;
        case GallectionType.COLLECTION:
            return collectionListSchema;
        case GallectionType.GALLERY:
        default:
            return galleryListSchema;
    }
}
export function normalizeGallection(gallection) {
    var schema = getGallectionSchema(gallection);
    var entities = normalize(gallection, schema).entities;
    return entities;
}
export function normalizeGallections(gallections) {
    var schema = getGallectionListSchema(gallections);
    var _a = normalize(gallections, schema), entities = _a.entities, result = _a.result;
    return { entities: entities, result: result };
}
export function normalizeDeviation(deviation) {
    var entities = normalize(deviation, deviationSchema).entities;
    return entities;
}
export function normalizeDeviations(deviations) {
    var _a = normalize(deviations, deviationListSchema), entities = _a.entities, result = _a.result;
    return { entities: entities, result: result };
}
export function normalizeUser(user) {
    var entities = normalize(user, userSchema).entities;
    return entities;
}
export function normalizeUsers(users) {
    var _a = normalize(users, userListSchema), entities = _a.entities, result = _a.result;
    return { entities: entities, result: result };
}
//# sourceMappingURL=helpers.js.map